/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'login-query': {
    width: 45,
    height: 45,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M501.76 907.264c-234.496 0-426.496-190.976-426.496-424.448s192-424.448 426.496-424.448 426.496 190.976 426.496 424.448c0 232.96-192 423.936-426.496 424.448zm0-73.216c194.56 0 353.28-158.208 353.28-351.744S696.32 131.072 501.76 131.072 148.48 289.28 148.48 482.816 307.2 834.048 501.76 834.048zm265.728 55.808c-14.848-13.824-11.264-37.888 3.584-48.128 14.848-10.24 40.96-10.24 52.224 3.584l71.168 79.36c14.848 13.824 11.264 37.888-3.584 48.128-14.848 10.24-40.96 10.24-52.224-3.584l-71.168-79.36z" _fill="#979797"/>'
  }
})
